import "./LoadingPage.css"

export default function LoadingPage() {
    return (
        <main className="app-container">
            <div className="loading-page">
                <h1>Loading Puzzle...</h1>
            </div>
        </main>
    )
}
